// extracted by mini-css-extract-plugin
export default {"content":"AuthContentWrapper_content__Hll-m","header":"AuthContentWrapper_header__ouRmm","goBackButton":"AuthContentWrapper_goBackButton__VK8L4"};